export default {
    OrganizationType: {
        Organization: 'Tổ chức',
        BusinessHousehold: 'Hộ kinh doanh'
    },
    AddBusinessHousehold: 'Thêm hộ kinh doanh',
    EditBusinessHousehold: 'Sửa hộ kinh doanh',
    IdentificationNumber: 'CCCD chủ hộ',
    InvoiceReceivedEmail: 'Email nhận hóa đơn:',
    HouseholdNote: 'Bắt buộc nhập 1 trong 2 thông tin “CCCD chủ hộ” hoặc “Mã số thuế”',
    SelectCompany: 'Chọn công ty:',
    AddCompany: 'Thêm công ty',
    EditCompany: 'Sửa công ty',
    AddCustomer: 'Thêm khách hàng',
    NameOrganization: 'Tên đơn vị',
    NameCustomer: 'Tên khách hàng',
    FullName: 'Họ và tên ',
    Address: 'Địa chỉ',
    Tel: 'Số điện thoại',
    Website: 'Website',
    CreateInvoiceEmail: 'Tạo email nhận hóa đơn',
    Email: 'Email',
    PaymentInfoNotRequired: 'Thông tin thanh toán (không bắt buộc)',
    BankName: 'Tên ngân hàng',
    BankAccountNo: 'Số TK ngân hàng',
    BankBranch: 'Chi nhánh',
    Cancel: 'Hủy',
    Complete: 'Hoàn thành',
    CreatedOrganization: 'Thêm chi nhánh, phòng ban',
    CreatedCustomer: 'Thêm khách hàng',
    EditOrganization: 'Sửa chi nhánh, phòng ban',
    EditCustomer: 'Sửa khách hàng',
    SuccessAddOrganization: 'Đã tạo thành công',
    SuccessEditOrganization: 'Đã sửa thành công',
    ManagementOrganization: 'Chi nhánh, phòng ban',
    ManagementCustomer: 'Quản lý khách hàng',
    SelectOrganization: 'Chọn đơn vị',
    SelectWorkingOrganization: 'Chọn đơn vị làm việc',
    ClickToCopyInvRevEmail: 'Nhấn để sao chép email nhận hóa đơn',
    DeclareOrganization: 'Khai báo khách hàng',
    Save: 'Lưu',
    WarningDataChange: '<span class="title-toast-message">Dữ liệu chưa đươc lưu.</span><br>Bạn có chắc chắn muốn hủy bỏ?',
    Edit: 'Chỉnh sửa',
    Delete: 'Xóa bỏ',
    ErrorDeleteWorking: 'Không thể xóa đơn vị đang làm việc. Vui lòng kiểm tra lại.',
    ErrorDeleteWorked: 'đã phát sinh dữ liệu. Bạn cần điều chuyển hết Hóa đơn/Tờ khai hải quan trước khi xóa.',
    ErrorDeleteCompanyHasChildren: 'Không thể xóa đơn vị đã có chi nhánh/phòng ban.',
    ErrorDeleteBranchHasChildren: 'Không thể xóa đơn vị đã có phòng ban.',
    ComfirmDelete: 'Bạn có chắc chắn muốn xóa',
    DeleteSuccess: 'Xóa thành công',
    PlaceholderSearch: 'Nhập Tên, Mã số thuế, CCCD chủ hộ, Email nhận hóa đơn để tìm kiếm',
    PlaceholderSearchCombobox: 'chương trình đang hiển thị nhập MST để tìm kiếm',
    Customer: 'Khách hàng',
    TaxCode: 'Mã số thuế',
    TaxCodeOrIdentification: 'Mã số thuế/CCCD chủ hộ',
    TitleTaxCode: 'Mã số thuế',
    InvRevEmail: 'Email nhận hóa đơn',
    InvoiceCount: 'HĐ đầu vào',
    OutInvoiceCount: 'HĐ đầu ra',
    DeclarationCount: 'Tờ khai hải quan',
    LastActive: 'Lần đăng nhập cuối',
    GuideOrganization: 'Chọn đơn vị để xem<br>hóa đơn',
    OrganizationInfo: 'Thông tin đơn vị',
    NameCompany: 'Tên công ty',
    NameCompanyLicense: 'Tên công ty (theo giấy phép kinh doanh)',
    NameHouseholdLicense: 'Tên hộ kinh doanh (theo giấy phép kinh doanh)',
    TextNameHouseholdLicense: 'Tên hộ kinh doanh',
    NameHouseholdOrCompanyLicense: 'Tên tổ chức/hộ kinh doanh (theo giấy phép kinh doanh)',
    AddressCompany: 'Địa chỉ',
    AddressCompanyLicense: 'Địa chỉ (trên giấy phép kinh doanh)',
    AcceptInvalid: 'Chấp nhận nhiều tên, địa chỉ đơn vị hợp lệ',
    ChangeUserUsing: 'Thay đổi người sử dụng',
    ChangeUserToDefault: fullname => `Sử dụng tài khoản <strong> ${fullname} </strong>`,
    KindChange: 'Loại',
    InfoAccept: 'Tên/địa chỉ được chấp nhận',
    StartDate: 'Ngày bắt đầu',
    EndDate: 'Ngày kết thúc',
    PersonAccept: 'Người chấp nhận',
    SubEmail: '@meinvoice.vn',
    HistoryChange: 'Lịch sử thay đổi GPKD',
    InfoBonusAccept: 'Thông tin chấp nhận được bổ sung',
    AddRow: 'Thêm dòng',
    CreateEmail: 'Tạo email để nhận hóa đơn',
    InfoCompany: 'Thông tin đơn vị',
    NotAddressAccept: 'Không có tên/địa chỉ được chấp nhận',
    TextNote: 'Kê khai thông tin Tên/Địa chỉ dựa theo các lần thay đổi giấy phép ĐKKD của đơn vị',
    ErrorDateChangeHistories: 'Khoảng hiệu lực của từng dòng không được trùng nhau',
    ViewAll: 'Xem tất cả',
    AddBranch: 'Thêm chi nhánh',
    EditBranch: 'Sửa chi nhánh',
    AddDepartment: 'Thêm phòng ban',
    EditDepartment: 'Sửa phòng ban',
    OrganizationStructure: 'Cơ cấu tổ chức',
    DepartmentName: 'Tên phòng ban',
    BranchName: 'Tên chi nhánh',
    BranchOrDepartmentName: 'Tên chi nhánh/phòng ban',
    //Bổ sung
    EmailTakeInvoice: 'Email nhận hóa đơn của bạn là:',
    GiveOrForwardEmailToHandle: `gửi hoặc chuyển tiếp (forward) email hóa đơn điện tử đến email này, hệ thống sẽ tự động xử lý hóa đơn.`,
    TimeEffect: 'Thời gian hiệu lực',
    OrgDetail: {
        LogDeleteInfo: {
            FirstText: 'Xóa thông tin tên/địa chỉ chấp nhận của',
            SecondText: 'có hiệu lực từ ngày',
            ThirdText: 'đến ngày'
        },
        LogEditInfo: {
            FirstText: 'Sửa ngày kết thúc thông tin tên/địa chỉ chấp nhận',
            SecondText: 'từ',
            ThirdText: 'thành'
        },
        CopyEmailSuccess: 'Sao chép email thành công'
    },
    NoData: 'Không có dữ liệu',
    TC: 'MST', // Tax code,
    OrgWidget: {
        AlertAddFirstBranchHaveDepartment: 'Chương trình sẽ chuyển MST, địa chỉ và các phòng ban từ công ty sang chi nhánh.',
        AlertAddFirstBranchNoDepartment: 'Chương trình sẽ chuyển email nhận hóa đơn, mã số thuế/căn cước công dân chủ hộ và các phát sinh (nếu có) từ công ty sang chi nhánh.',
        AlertAddFirstBranchNoDepartment2: 'Chương trình sẽ chuyển email nhận hóa đơn, mã số thuế và các phát sinh (nếu có) từ công ty sang chi nhánh.',
        AlertAddFirstDepartmentFromCompany: 'Chương trình sẽ chuyển email nhận hóa đơn và các phát sinh (nếu có) từ công ty sang phòng ban.',
        AlertAddFirstDepartmentFromBranch: 'Chương trình sẽ chuyển email nhận hóa đơn và các phát sinh (nếu có) từ chi nhánh sang phòng ban.',
        CreateBranchSuccess: 'Tạo chi nhánh thành công',
        CreateDepartmentSuccess: 'Tạo phòng ban thành công',
        DeleteCompany: 'Xóa công ty',
        DeleteBranch: 'Xóa chi nhánh',
        DeleteDepartment: 'Xóa phòng ban',
        DeletedCompanySuccess: 'Đã xóa công ty thành công',
        DeletedBranchSuccess: 'Đã xóa chi nhánh thành công',
        DeletedDepartmentSuccess: 'Đã xóa phòng ban thành công',
        WannaDeleteCompany: 'Bạn muốn xóa công ty',
        WannaDeleteBranch: 'Bạn muốn xóa chi nhánh',
        WannaDeleteDepartment: 'Bạn muốn xóa phòng ban',
        PrefixCompany: name => `<span class='font-bold'>Công ty ${name}</span>`,
        PrefixBranch: name => `<span class='font-bold'>Chi nhánh ${name}</span>`,
        PrefixDepartment: name => `<span class='font-bold'>Phòng ban ${name}</span>`,
        ConfirmDeleteWithChild: {
            FirstText: 'Bạn có chắc chắn muốn xóa',
            SecondText: 'và các đơn vị cấp dưới tương ứng không?'
        },
        ConfirmDeleteWithNoChild: {
            FirstText: 'Bạn có chắc chắn muốn xóa',
            SecondText: 'không?'
        }
    },
    OrgStructure: {
        DeclareInfo: 'Kê khai thông tin Tên/Địa chỉ dựa theo các lần thay đổi giấy phép ĐKKD của đơn vị'
    },
    FoundedDate: 'Ngày hiệu lực',
    TooltipFoundedDate: 'Ngày hiệu lực bắt đầu của tên, địa chỉ theo giấy phép kinh doanh',
    ChangeEmailReceive: 'Thay đổi địa chỉ email',
    EmailReceiveText: `Email nhận hóa đơn của bạn là:`,
    EmailReceiveTextNote: `Sau khi thay đổi, bạn sẽ không nhận được hóa đơn gửi tới địa chỉ email <span class='font-bold'>cũ</span>. Vui lòng thông báo người bán gửi email vào địa chỉ email <span class='font-bold'>mới</span> để tránh thất lạc hóa đơn.`,
    EmailNew: 'Địa chỉ email mới',
    EmailOld: 'Địa chỉ email cũ',
    UpdateEmailReceiveSuccess: 'Cập nhật địa chỉ email nhận hóa đơn thành công',
    EmailNewSameAsOldTooltip: 'Địa chỉ email mới không được trùng với địa chỉ email cũ',
    EmailNewRequiredMsg: 'Địa chỉ email mới không được để trống',
    ChangeEmailReceiveFailed: 'Thay đổi địa chỉ email không thành công',
    ChangeEmailFailedTitle: 'Thay đổi địa chỉ email không thành công',
    TextGuideDetail: {
        Text0: 'Nếu một hộ kinh doanh có ',
        Text1: 'Nếu một công ty có ',
        Text2: 'nhiều chi nhánh, phòng ban ',
        Text3: 'nhận hóa đơn, để quản lý tập trung hóa đơn, bạn có thể thêm các chi nhánh/phòng ban thuộc công ty.',
        Text4: 'nhận hóa đơn, để quản lý tập trung hóa đơn, bạn có thể thêm các chi nhánh/phòng ban thuộc hộ kinh doanh.'
    },
    PersonalIdRequired: 'CCCD chủ hộ không được để trống',
    ChangeTypeOrganizationNote: 'Việc thay đổi loại hình từ "Tổ chức" sang "Hộ kinh doanh" cho phép bạn khai báo thêm thông tin CCCD chủ hộ để phục vụ kiểm tra hóa đơn chính xác hơn. Sau khi đổi loại hình, bạn không thể chọn lại. Vui lòng đảm bảo chọn đúng loại hình phù hợp.',
    NotSupportChange: 'Không hỗ trợ thay đổi loại hình từ "Hộ kinh doanh" sang "Tổ chức" để hạn chế ảnh hưởng đến kết quả kiểm tra hóa đơn cũ. Vui lòng đảm bảo chọn đúng loại hình phù hợp từ khi tạo Công ty/Phòng ban/Chi nhánh.',
    NotTheSameIdentity: 'CCCD chủ hộ và Mã số thuế không phải của cùng 1 đối tượng. Bạn có chắc chắn muốn lưu không?',
    UpdateCCCDBtn: 'Cập nhật CCCD trên cơ cấu tổ chức',
    UpdateCCCDPopup: {
        Title: 'Cập nhật Căn cước công dân trên cơ cấu tổ chức',
        NotificationSuccess: identificationText => `Bạn đã ${identificationText} và đăng nhập được vào phần mềm.`,
        IdentificationText: identification => `cập nhật thành công CCCD số ${identification}`,

        NotificationInstruction: orgText =>
            `Tiếp theo, bạn cần cập nhật CCCD vào ${orgText} để kết quả kiểm tra hóa đơn được chính xác. Chọn đơn vị:`,
        ConfirmationText: 'Tôi xác nhận và hoàn toàn chịu trách nhiệm về cập nhật CCCD trên cơ cấu tổ chức',
        Buttons: {
            Skip: 'Để sau',
            UpdateNow: 'Cập nhật ngay'
        },
        Messages: {
            UpdateSuccess: 'Cập nhật thành công CCCD trên cơ cấu tổ chức',
            UpdateError: 'Có lỗi xảy ra khi cập nhật CCCD. Vui lòng thử lại.'
        }
    },
    SelectToUpdate: 'Chọn để cập nhật CCCD thay cho MST',
    PopupDeleteIdentificationNumber: 'Xóa căn cước công dân',
    ContentPopupDeleteIdentificationNumber: 'Việc xóa căn cước công dân có thể làm ảnh hưởng đến dữ liệu trên phần mềm của bạn. Bạn có muốn tiếp tục lưu?',
    UpdateCCCDTitle: 'Cập nhật lại số Căn cước công dân',
    CCCDChangeMessage: 'Bạn muốn cập nhật số CCCD',
    ChangeTo: 'thay cho CCCD',
    CCCDImpact1: 'Việc cập nhật lại CCCD sẽ làm <span style="font-weight: 700;color: #FF9F0E;">ảnh hưởng để dữ liệu cơ cấu tổ chức của bạn</span>, vui lòng nhấn <span style="font-weight: 700;color: #212529;">Xác nhận</span> để tiến hành cập nhật.',
    CCCDImpact2: 'Các dữ liệu có thể bị hưởng: Kết quả kiểm tra hóa đơn, Kết nối CQT, Thiết lập điều chuyển hóa đơn từ nguồn email, Cơ cấu tổ chức,...',
    CCCDImpact3: 'Sau khi hoàn tất cập nhật CCCD, việc quản lý dữ liệu trên phần mềm sẽ sử dụng CCCD mới.',
    ViewGuide: 'Xem hướng dẫn',
    Confirm: 'Xác nhận',
    ToastUpdateSuccess: 'Hoàn tất cập nhật dữ liệu cơ cấu tổ chức',
    DoConfirm: 'Vui lòng tích chọn “Tôi xác nhận và hoàn toàn chịu trách nhiệm về cập nhật CCCD trên cơ cấu tổ chức” trước khi nhấn <strong> Cập nhật ngay</strong>.',
    SelectAtLeastItem: 'Vui lòng chọn ít nhất 1 dòng thông tin đơn vị trước khi nhấn <strong> Cập nhật ngay</strong>.',
    UpdateOrgWarning: 'Vui lòng chọn ít nhất 1 dòng thông tin đơn vị và tích chọn “Tôi xác nhận và hoàn toàn chịu trách nhiệm về cập nhật CCCD trên cơ cấu tổ chức” trước khi nhấn <strong> Cập nhật ngay</strong>.',
    HandleOtherInvoice: 'Sử dụng phần mềm để kiểm tra hóa đơn của bên thứ 3.',
    HandleOtherInvoiceSetupWarning: 'Bạn đang thiết lập đơn vị là đối tượng sử dụng phần mềm để kiểm tra hóa đơn của bên thứ 3. Sau khi bạn chọn Lưu, thiết lập này sẽ được cố định và không thể thay đổi.',
    DeclareInfoAccuracyNote: 'Vui lòng khai báo thông tin <strong>chính xác theo giấy phép kinh doanh</strong>. Hệ thống sẽ sử dụng thông tin này để tra cứu tính pháp lý của hóa đơn.',
    VerifyBuyerSellerInfo: 'Chương trình sẽ kiểm tra thông tin người mua, người bán trên hóa đơn theo dữ liệu từ Cơ quan thuế.',
    DeclaredInfoNotUsedNote: 'Các thông tin đơn vị khai báo sẽ <strong>không sử dụng</strong> để kiểm tra hóa đơn.',
    ThirdPartyInvoiceSetupLocked: 'Đơn vị đã được thiết lập sử dụng phần mềm để kiểm tra hóa đơn của bên thứ ba. Chương trình không hỗ trợ thay đổi để hạn chế ảnh hưởng đến kết quả kiểm tra hóa đơn cũ.',
    ThirdPartyInvoiceSetupConfirmed: 'Đơn vị đã được thiết lập sử dụng phần mềm để kiểm tra hóa đơn của bên thứ 3.',
    CheckOwnUnitCreateNewCompany: 'Nếu bạn muốn kiểm tra hóa đơn cho chính đơn vị của mình, vui lòng tạo thêm một công ty mới để thực hiện.',
    OwnUnitInvoiceSetupLocked: 'Đơn vị đã được thiết lập sử dụng phần mềm để kiểm tra hóa đơn cho chính đơn vị của mình. Chương trình không hỗ trợ thay đổi để hạn chế ảnh hưởng đến kết quả kiểm tra hóa đơn cũ.',
    CheckThirdPartyCreateNewCompany: 'Nếu bạn muốn kiểm tra hóa đơn của bên thứ ba, vui lòng tạo thêm một công ty mới để thực hiện.',
    OrganizationLimitReached: maxCount => `Số lượng đơn vị trong cơ cấu tổ chức đã đạt giới hạn tối đa là ${maxCount}. Để thêm đơn vị mới, vui lòng xóa bớt các đơn vị không còn sử dụng.\nLưu ý: Trước khi xóa, bạn cần điều chuyển toàn bộ Hóa đơn/Tờ khai hải quan của đơn vị đó sang một đơn vị khác.`,
    CannotAddNewUnit: 'Không thể thêm đơn vị mới',
    CannotChangeSettings: 'Không thể thay đổi thiết lập'
};